/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-08 11:54:30
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2020-09-08 11:57:19
 */
import Vue from 'vue'
import { Toast, Overlay, Sticky, Tab, Tabs } from 'vant'
import alert_icon from '@/assets/alert_icon.png'
import 'vant/lib/toast/style'
Toast.setDefaultOptions({
  duration: 3000,
  //icon: 'https://qiniu.wlwyl.com/04fcd502651047e39d94816b2cf82f15',
  icon: alert_icon,
  className: 'kigo-toast',
  transition: 'kigo-toast-transition'
})
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Sticky)
Vue.use(Tab)
Vue.use(Tabs)
